import React, { useRef, useCallback, useLayoutEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'gatsby';
import useMediaQuery from '../hooks/useMediaQuery';

const VideoSlider = () => {
  const [sliderUnmute, setSliderUnmute] = useState(null);

  const isMobile = useMediaQuery('(max-width: 767px)');

  const sliderRef = useRef();

  const toggleVideoMute = useCallback(
    (index) => () => {
      setSliderUnmute((state) => (state === index ? null : index));
    },
    [],
  );

  const onSliderChange = useCallback((index) => {
    const videos = document.querySelectorAll(`video[data-id]`);
    let vidArr = Array.from(videos);
    let vid;
    if (isMobile) {
      vid = vidArr.slice(2, 8);
    } else {
      vid = vidArr.slice(4, 10);
    }

    console.log(vid);
    vid.forEach((video) => {
      if (video.dataset.id === index.toString()) {
        video.load();
        video.play();
      } else {
        video.pause();
      }
    });
  }, []);

  useLayoutEffect(() => {
    const timeout = setTimeout(() => {
      const video = document.querySelector('video[data-id="0"]');

      if (video) {
        video.play();
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <section className="videoSlider">
      <div className="small-container">
        <div className="why-index-content flex-row no-margin">
          <div className="col col-5">
            <h5 className="yellow-heading ">Why Videos?</h5>
            <h3>You’re more than your job history</h3>
          </div>
          <div className="col col-6 offset-1">
            <p>
              <span className="small-stroke">Why a video introduction? </span>{' '}
              Because your job history doesn’t tell your whole story. ClipHire
              showcases who you are beyond your resume.
            </p>
            <p>
              Build your career and get hired faster with a shareable link to
              everything employers want to see.They’ll be able to review your
              resume, check your references, message you, and set up an
              interview on your calendar - all in one place. (Hiring managers
              love a candidate who makes their job easier.)
            </p>
            <Link
              to="/"
              className="purple"
              style={{ marginTop: '20px', display: ' inline-block' }}>
              Create a video resume
              <img src="/img/arrow-right.svg" alt="" className="arrow-right" />
            </Link>
          </div>
        </div>
      </div>
      <div className="position-relative  video-slider-main">
        <span className="big-gradient-circle red-gradient" />
        <span className="big-gradient-circle" />
        <Slider
          ref={sliderRef}
          className="center"
          arrows
          pauseOnHover={false}
          centerMode
          // initialSlide={2}
          infinite
          centerPadding="200px"
          slidesToShow={5}
          speed={500}
          afterChange={onSliderChange}
          responsive={[
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                centerPadding: '45px',
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 990,
              settings: {
                centerPadding: '0',
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 767,
              settings: {
                centerPadding: '45px',
                slidesToShow: 1,
              },
            },
          ]}>
          <div>
            <div className="case-card">
              <div className="case-video">
                <img src="/img/video-1.jpg" alt="" />
                <video
                  data-id="0"
                  src="/video/video-1.mp4"
                  muted={sliderUnmute === 0 ? false : true}
                />
                <button
                  type="button"
                  className="mute"
                  onClick={toggleVideoMute(0)}>
                  <img
                    src="/img/mute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 0 ? `` : `show`
                    }`}
                  />
                  <img
                    src="/img/unmute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 0 ? `show` : ``
                    }`}
                  />
                </button>
              </div>
              <div className="case-content">
                <p>
                  It was really surprising to me how many interview requests I
                  received from companies after sharing my ClipHire profile with
                  recruiters.
                </p>
                <div className="case-footer flex-row no-margin">
                  <p>- Josh Donovan</p>
                  <Link to="/" className="read-case">
                    Read Case
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="case-card">
              <div className="case-video">
                <img src="/img/video-2.jpg" alt="" />
                <video
                  data-id="1"
                  src="/video/video-2.mp4"
                  muted={sliderUnmute === 1 ? false : true}
                />
                <button
                  type="button"
                  className="mute"
                  onClick={toggleVideoMute(1)}>
                  <img
                    src="/img/mute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 1 ? `` : `show`
                    }`}
                  />
                  <img
                    src="/img/unmute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 1 ? `show` : ``
                    }`}
                  />
                </button>
              </div>
              <div className="case-content">
                <p>
                  I love how ClipHire makes me feel in control of my job search.
                  The video feature of ClipHire gave me a lot of confidence
                  looking for a new job.
                </p>
                <div className="case-footer flex-row no-margin">
                  <p>- Lauren Winfrey</p>
                  <Link to="/" className="read-case">
                    Read Case
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="case-card ">
              <div className="case-video">
                <img src="/img/video-3.jpg" alt="" />
                <video
                  data-id="2"
                  src="/video/video-3.mp4"
                  muted={sliderUnmute === 2 ? false : true}
                />
                <button
                  type="button"
                  className="mute"
                  onClick={toggleVideoMute(2)}>
                  <img
                    src="/img/mute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 2 ? `` : `show`
                    }`}
                  />
                  <img
                    src="/img/unmute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 2 ? `show` : ``
                    }`}
                  />
                </button>
              </div>
              <div className="case-content">
                <p>
                  I work in an industry that is saturated with talent. I loved
                  using ClipHire to land interviews because it helped me stand
                  out from other applicants for the roles that I applied for
                </p>
                <div className="case-footer flex-row no-margin">
                  <p>- Anthony Gersczeck</p>
                  <Link to="/" className="read-case">
                    Read Case
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="case-card ">
              <div className="case-video">
                <img src="/img/video-4.jpg" alt="" />
                <video
                  data-id="3"
                  src="/video/video-4.mp4"
                  muted={sliderUnmute === 3 ? false : true}
                />
                <button
                  type="button"
                  className="mute"
                  onClick={toggleVideoMute(3)}>
                  <img
                    src="/img/mute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 3 ? `` : `show`
                    }`}
                  />
                  <img
                    src="/img/unmute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 3 ? `show` : ``
                    }`}
                  />
                </button>
              </div>
              <div className="case-content">
                <p>
                  ClipHire helped me get my foot in the door because I was able
                  to tell what I brought to the table that my resume didn’t tell
                  when changing careers.
                </p>
                <div className="case-footer flex-row no-margin">
                  <p>- Katrina Bivens</p>
                  <Link to="/" className="read-case">
                    Read Case
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="case-card ">
              <div className="case-video">
                <img src="/img/video-5.jpg" alt="" />
                <video
                  data-id="4"
                  src="/video/video-5.mp4"
                  muted={sliderUnmute === 4 ? false : true}
                />
                <button
                  type="button"
                  className="mute"
                  onClick={toggleVideoMute(4)}>
                  <img
                    src="/img/mute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 4 ? `` : `show`
                    }`}
                  />
                  <img
                    src="/img/unmute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 4 ? `show` : ``
                    }`}
                  />
                </button>
              </div>
              <div className="case-content">
                <p>
                  As an engineer, most applicants are judged strictly based on
                  their experience on paper. Cliphire helped me add that extra
                  touch to get interviews over other applicants.
                </p>
                <div className="case-footer flex-row no-margin">
                  <p>- Sarah Hall</p>
                  <Link to="/" className="read-case">
                    Read Case
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="case-card ">
              <div className="case-video">
                <img src="/img/video-6.jpg" alt="" />
                <video
                  data-id="5"
                  src="/video/video-6.mp4"
                  muted={sliderUnmute === 5 ? false : true}
                />
                <button
                  type="button"
                  className="mute"
                  onClick={toggleVideoMute(5)}>
                  <img
                    src="/img/mute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 5 ? `` : `show`
                    }`}
                  />
                  <img
                    src="/img/unmute.svg"
                    alt=""
                    className={`mute-button ${
                      sliderUnmute === 5 ? `show` : ``
                    }`}
                  />
                </button>
              </div>
              <div className="case-content">
                <p>
                  I was looking for a job in a different industry than my
                  experience. ClipHire really helped me put my reasoning into
                  works that my resume didn’t tell.
                </p>
                <div className="case-footer flex-row no-margin">
                  <p>- Daniel Maw</p>
                  <Link to="/" className="read-case">
                    Read Case
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default VideoSlider;
